// import packages
import gql from "graphql-tag"

// export gqls
export const GET_CATEGORIES = gql`
  query Categories($take: Int, $skip: Int) {
    categories(take: $take, skip: $skip) {
      total
      data {
        id
        name
        isEnable
        subcategories {
          id
          name
          isEnable
        }
      }
    }
  }
`
export const SUM_CATEGORIES = gql`
  query Categories {
    categories(take: 0) {
      total
    }
  }
`

export const GET_CATEGORY = gql`
  query Categories($id: ID!) {
    category(id: $id) {
      id
      name
      isEnable
      subcategories {
        id
        name
        isEnable
      }
    }
  }
`

export const UPDATE_CATEGORY = gql`
  mutation UpdateCategory($id: ID!, $input: CategoryUpdateInput!) {
    updateCategory(id: $id, input: $input) {
      id
    }
  }
`

export const CREATE_CATEGORY = gql`
  mutation CreateCate($input: CategoryCreateInput!) {
    createCategory(input: $input) {
      id
    }
  }
`

export const DELETE_CATEGORY = gql`
  mutation DeleteCategory($id: ID!) {
    deleteCategory(id: $id)
  }
`

export const UPDATE_SUBCATEGORY = gql`
  mutation UpdateSubCategory($id: ID!, $input: SubcategoryUpdateInput!) {
    updateSubcategory(id: $id, input: $input) {
      id
    }
  }
`

export const CREATE_SUBCATEGORY = gql`
  mutation CreateSubCategory($input: SubcategoryCreateInput!) {
    createSubcategory(input: $input) {
      id
    }
  }
`

export const DELETE_SUBCATEGORY = gql`
  mutation DeleteSubCategory($id: ID!) {
    deleteSubcategory(id: $id)
  }
`
